import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  /** Active request counter — loader is visible while count > 0. */
  private count = 0;
  private countSubject = new BehaviorSubject<number>(0);

  /** Emits true when at least one request is active; false when all are done. */
  loader$: Observable<boolean> = this.countSubject.pipe(
    map(n => n > 0),
    distinctUntilChanged(),
  );

  show(): void {
    this.countSubject.next(++this.count);
  }

  hide(): void {
    if (this.count > 0) {
      this.countSubject.next(--this.count);
    }
  }
}
